module.exports = __webpack_public_path__ + "static/media/col4.8def0917.svg";